module.exports = __webpack_public_path__ + "media/src/images/alert-triangle-c6aafa9082083e308e85aa3366545ab0.svg";